import { takeLatest, takeEvery, put, call, all, select } from 'redux-saga/effects';
import { user, toast, modal, loading, project, auth, partners, serviceRequest, chat } from '../types';
import { getNewAuthToken, getOrgId, uploadFileToS3WithSignedUrlNew } from '../utils/common';
import scogo_apis from '../scogo_apis';
import { VerifyAadharOtp } from '../pages/Onboard/Fields';
import iceberg_apis from '../iceberg_apis'
import config from '../config';
import { addNewVendorFromPoFormName } from '../components/RaisePO/AddNewVendor';

export function* updateUserStatus(action) {
    const { userId, status, duration, remark, formName } = action.payload;
    let queryParams = { status };
    if (duration) queryParams.duration = duration;
    if (remark) queryParams.remark = remark;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.updateUserStatus, {}, { userId }, {}, queryParams);
        if (response.status === 200) {
            const toastMessage = response.data.message;
            yield put({ type: user.UPDATE_USER_STATUS_PROFILE_SUCCESS, payload: { updatedUser: response.data.data } });
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: toastMessage } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: Array.isArray(error.response.data.messages) ? error.response.data.messages[0] : error.response.data.messages || 'Something Went Wrong!!' } });
        yield put({ type: user.UPDATE_USER_STATUS_FAILURE, payload: { message: error } });
    }


    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });

}

export function* updatePartnersProfile(action) {
    const { userId, first_name, last_name, email, companyName, net_plan, net_provider, is_enabled, formName, tabName = '' } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.updateProfile, {}, { userId }, {}, { first_name, last_name, email, companyName, net_plan, net_provider, is_enabled });
        if (response.status === 200) {
            yield all([
                yield put({ type: modal.CLOSE_MODAL }),
                yield put({ type: user.UPDATE_PARTNER_PROFILE_SUCCESS, payload: response.data }),
                yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Profile Updated Succesfully' } }),
            ]);

            if (tabName === 'customer_vendors') { // 4.0 
                // yield put({ type: customer.GET_CUSTOMER_VENDORS_LIST_REQUEST, payload: { customer_id: customerId } });
            }
        } else {
            yield all([
                yield put({ type: modal.CLOSE_MODAL }),
                yield put({ type: user.UPDATE_PARTNER_PROFILE_FAILURE, payload: { message: 'Oops Something went wrong' } }),
                yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } }),
            ]);
        }
    } catch (error) {
        yield put({ type: user.UPDATE_PARTNER_PROFILE_FAILURE, payload: { message: error } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
};

export function* getUserDetails(action) {
    const { userId } = action.payload;
    const queryparams = {
        giveTeams: true,
    };
    try {
        yield put({ type: loading.GET_USER_DETAILS_LOADING, payload: true });
        const response = yield call(scogo_apis.user.getUserDetails, {}, { userId }, queryparams, {});
        if (response.status === 200) {
            const userDetails = response.data;
            yield put({ type: user.GET_USER_DETAILS_SUCCESS, payload: userDetails });
        } else {
            yield put({ type: user.GET_USER_DETAILS_SUCCESS, payload: null });
            yield put({ type: user.GET_USER_DETAILS_FAILURE, payload: { message: 'Oops Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: user.GET_USER_DETAILS_FAILURE, payload: { message: error } });
    }
    yield put({ type: loading.GET_USER_DETAILS_LOADING, payload: false });
}

export function* retrievesUserDetails(action) {
    const { userId } = action.payload
    try {
        const response = yield call(scogo_apis.user.getUserDetail, {}, { id: userId })
        if (response.status === 200) {
            yield put({ type: user.RETRIEVES_TEAMS_USER_DETAILS_SUCCESS, payload: response.data })
        }
    } catch (error) {
        yield put({ type: user.RETRIEVES_TEAMS_USER_DETAILS_FAILURE, payload: { message: error } })
    }
};

export function* getOnboardingFlow(action) {
    const { role_ids } = action.payload;
    const data = {}
    if (role_ids) data.role_ids = role_ids;
    try {
        yield put({ type: user.GET_ONBOARDING_FLOW_SUCCESS, payload: { data: [] } });
        yield put({ type: loading.ONBOARDING_FIELDS_LOADING, payload: true })
        const response = yield call(scogo_apis.user.getOnboardingFlow, {}, {}, data);
        if (response.status === 200) {
            yield put({ type: user.GET_ONBOARDING_FLOW_SUCCESS, payload: { data: response.data.data } });
        } else {
            yield put({ type: user.GET_ONBOARDING_FLOW_FAILURE, payload: { message: 'Something Went Wrong!!' } });
        }
    } catch (error) {
        yield put({ type: user.GET_ONBOARDING_FLOW_SUCCESS, payload: { data: [] } });
        yield put({ type: user.GET_ONBOARDING_FLOW_FAILURE, payload: { message: 'Something Went Wrong!!', } });
    }
    yield put({ type: loading.ONBOARDING_FIELDS_LOADING, payload: false })
}

export function* inviteUserRequest(action) {
    let { org_id, role_ids, fields, resetOnSuccess, formName, user_id } = action.payload
    const { inviteFormImagesUrls } = yield select((state) => state.user);

    fields = fields.map(({ ref, data_type, value }) => {
        // if (data_type === 'IMG') {
        //     return { ref, value: inviteFormImagesUrls[ref] }
        // }
        return { ref, value }
    })
    const requestBody = { org_id, role_ids, fields };
    if (user_id) requestBody.id = user_id;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.postInviteLink, {}, {}, {}, requestBody);

        if (response.status === 201) {
            if (formName === addNewVendorFromPoFormName) {
                yield put({ type: user.ADD_VENDOR_FROM_PO_SUCCESS, payload: response.data });
                yield put({ type: modal.CLOSE_MODAL });
            }
            yield put({ type: user.INVITE_USER_POST_SUCCESS, payload: response.data });
            yield put({
                type: toast.SEND_TOAST, payload: {
                    status: 'success',
                    message: response?.data?.message
                }
            });
            if (typeof resetOnSuccess === 'function') {
                resetOnSuccess();
            }
        } else {
            yield put({
                type: toast.SEND_TOAST, payload: {
                    status: 'danger',
                    message: response.data?.message || "Something went wrong"
                }
            });
        }
    } catch (error) {
        console.log('error:', error)
        yield put({
            type: toast.SEND_TOAST, payload: {
                status: 'danger',
                message: error.response?.data?.messages?.[0] || "Something went wrong"
            }
        });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
};

export function* getOnboardingProgress(action) {
    const { step, org } = action.payload;
    try {
        const response = yield call(scogo_apis.user.onboardingProgress, {}, { orgId: org }, {}, {});
        if (response.status === 200) {
            yield put({ type: user.GET_ONBOARDING_PROGRESS_SUCCESS, payload: response.data })
        }
        else {
            yield put({ type: user.GET_ONBOARDING_PROGRESS_FAILURE, payload: { message: 'Something Went Wrong !!' } });
        }
    } catch (error) {
        yield put({ type: user.GET_ONBOARDING_PROGRESS_FAILURE, payload: { message: 'Something Went Wrong !!' } });
    }
}

export function* getUserTableSchema(action) {
    const { user_id, org_id, module = "USER", tab, type = "COLUMN" } = action.payload;
    const queryParams = { user_id, org_id, module, type };
    const { rolesList } = yield select((state) => state.partners);
    const role = rolesList && rolesList.find(({ path }) => path === tab && !['all', 'verification_pending'].includes(tab));
    if (role) queryParams.level_id = role.id;
    const newLoggedUserData = yield select((state) => state.auth.newLoggedUserData);
    queryParams.role_id = newLoggedUserData.user.roles.map(({ id }) => id).join(',');
    if (tab && tab === 'verification_pending') {
        queryParams.level_id = 'VERIFICATION_PENDING'
    }
    if (tab && tab === 'all') {
        queryParams.level_id = 'ALL'
    }

    try {
        yield put({ type: loading.SET_USER_TABLE_SCHEMA_LOADING, payload: true });
        const response = yield call(scogo_apis.user.getUserPreferences, {}, {}, queryParams);
        if (response.status === 200) {
            yield put({ type: user.GET_USER_TABLE_SCHEMA_SUCCESS, payload: { data: response.data, tab } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
    }
    yield put({ type: loading.SET_USER_TABLE_SCHEMA_LOADING, payload: false });
};

export function* postImageUrl(action) {
    let { files, ref, purpose, additionalData, ticket_id, milestone_id, task_id, project_id, user_id, bulk_type, onSuccess = () => { }, onError = () => { }, closeModal = false, chat_id, panOrAadharUpload, formName } = action.payload;
    files = Array.from(files);
    const requestBody = {
        files: files.map(file => ({
            name: file.name,
            mime_type: file.type,
            size: file.size
        })),
        purpose,
        additionalData
    };
    if (ticket_id) requestBody.ticket_id = ticket_id;
    if (milestone_id) requestBody.milestone_id = milestone_id;
    if (task_id) requestBody.task_id = task_id;
    if (project_id) requestBody.project_id = project_id;
    if (user_id) requestBody.user_id = user_id;
    if (bulk_type) requestBody.bulk_type = bulk_type
    if (chat_id) requestBody.chat_id = chat_id
    try {
        if (formName) {
            yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        }
        if (panOrAadharUpload) {
            yield put({ type: loading.PAN_OR_AADHAR_LOADING, payload: true });
        }
        const postImageUrlApi = scogo_apis.user.postImageUrl;
        const response = yield call(postImageUrlApi, {}, {}, {}, requestBody);
        if (response.status !== 201) throw new Error('Failed to get signed URL');

        const postUrls = response?.data?.data?.postUrls;
        const projectId = response?.data?.data?.projectId;
        const userId = response?.data?.data?.userId;

        yield Promise.all(
            files.map(async (file) => {
                const f = postUrls.find(({ name }) => name === file.name);
                if (!f) {
                    console.error(`No signed URL found for file: ${file.name}`);
                    return;
                }

                const body = {
                    'Content-Type': f.mimeType,
                    'key': f.payload.key,
                    ...(f.payload.acl ? { 'acl': f.payload.acl } : {}),
                    'X-Amz-Date': f.payload.date,
                    'X-Amz-Algorithm': f.payload.algorithm,
                    'x-amz-meta-uuid': f.payload.uuid,
                    'X-Amz-Credential': f.payload.credential,
                    'Policy': f.payload.policy,
                    'X-Amz-Signature': f.payload.signature,

                };

                try {
                    await uploadFileToS3WithSignedUrlNew(f.postUrl, file, body);
                    console.log(`File uploaded successfully: ${file.name}`);
                } catch (uploadError) {
                    console.error(`Error uploading file ${file.name}:`, uploadError);
                }
            })
        );

        let dataToSave = postUrls[0].fileUrl;
        if (purpose === 'PAV_ATTACHMENT') {
            dataToSave = postUrls.map((uploadedFile) => {
                const sourceFile = files.find((file) => file.name === uploadedFile.name);
                return {
                    file_url: uploadedFile.fileUrl,
                    name: uploadedFile.name,
                    mime_type: uploadedFile.mimeType,
                    size: sourceFile?.size || 0,
                };
            });
        } else if (['CHAT', 'TICKET_TASK', 'PROJECT_POST'].includes(purpose)) {
            dataToSave = {
                file_url: postUrls[0].fileUrl,
                name: files[0].name,
                mime_type: files[0].type,
                caption: '',
                size: files[0].size
            }
        }

        if (projectId) {
            yield put({ type: project.PRE_CREATED_PROJECT_ID, payload: { projectId } });
        }
        if (closeModal) {

            yield put({ type: modal.CLOSE_MODAL })
        }
        onSuccess(dataToSave, userId)
        yield put({
            type: user.POST_IMAGE_URL_SUCCESS,
            payload: {
                data: dataToSave,
                ref
            }
        });

    } catch (error) {
        console.error('Error in postImageUrl saga:', error);
        onError(error);
        yield put({ type: user.POST_IMAGE_URL_FAILURE, payload: error.message });
    }
    // if (panOrAadharUpload) {
    //     yield put({ type: loading.PAN_OR_AADHAR_LOADING, payload: false });
    // }
    if (formName) {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* updateUserPreferences(action) {
    const { user_id, org_id, module = "USER", event = 'USER_LISTING', attributes, tab, preference_id, level, role_id } = action.payload;
    const { rolesList } = yield select((state) => state.partners);
    const findRole = rolesList && rolesList.find(({ path }) => path === tab && !['all', 'verification_pending'].includes(tab));
    const body = { user_id, org_id, module, event, attributes };
    if (findRole) body.role_id = findRole.id;
    if (role_id) body.role_id = role_id;
    if (level) body.level = level;

    try {
        yield put({ type: loading.SET_UPDATE_USER_TABLE_SCHEMA_LOADING, payload: true });
        const response = yield call(scogo_apis.user.updateUserPreferences, {}, { preferenceId: preference_id }, {}, body);
        if (response.status === 200) {
            yield put({ type: user.UPDATE_USER_PREFERENCES_SUCCESS, payload: { data: response.data.data, tab } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
    }
    yield put({ type: loading.SET_UPDATE_USER_TABLE_SCHEMA_LOADING, payload: false });
};

export function* getAddBankDetailsFields(action) {
    const { countryId } = action.payload

    try {
        const response = yield call(scogo_apis.user.getBankFields, {}, { id: countryId }, {})

        if (response.status === 200) {
            yield put({ type: user.GET_ADD_BANK_DETAILS_FIELD_SUCCESS, payload: response.data })
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } })
    }
}

export function* postBankDetails(action) {
    const { userId, bank_details, callUserDetails, closeModal = true, callMe = false, formName } = action.payload
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.postBankDetails, {}, { id: userId }, {}, bank_details);
        if (response.status === 201) {
            if (callMe) yield put({ type: auth.USER_PROFILE_REQUEST, payload: { give_actions: false, navigate: () => { } } })
            if (callUserDetails) yield put({ type: user.GET_USER_DETAILS_BY_ID_REQUEST, payload: { user_id: userId } })
            if (closeModal) yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Bank Details Added ' } })
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
};


export function* postBulkInvite(action) {
    const { payloadData } = action.payload
    if (payloadData.roles.length === 0) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Please select role ' } })
    }


    try {
        const response = yield call(scogo_apis.user.postBulkInvite, {}, {}, {}, { ...payloadData })

        if (response.status === 201) {
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Bank Details Added ' } })
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
    }
};


export function* updateBusinessDetail(action) {
    const { payload } = action.payload

    try {
        const response = yield call(scogo_apis.user.updateBusinessDetail, {}, {}, {}, { payload });
        if (response.status === 200) {
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Details updated' } })
            yield put({ type: user.UPDATE_BUSINESS_DETAILS_SUCESS, payload: response.data })
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
    }
}

// new saga functions
export function* updateUserProfile(action) {
    const { payload, userId, formName, callLoginUserDetails, refreshList = true } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.updateUserProfile, {}, { userId }, {}, payload);

        if (response.status === 200) {
            if (callLoginUserDetails) {
                yield put({ type: auth.USER_PROFILE_REQUEST, payload: { give_actions: false, navigate: () => { } } });
            } else if (refreshList) {
                yield put({ type: partners.REFRESH_PARTNER_FILTER_REQUEST });
            }
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Details updated' } })
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}
export function* getUserGst(action) {
    try {
        yield put({ type: loading.GET_GST_LIST_LOADING, payload: true });
        const response = yield call(scogo_apis.user.getUserGst, {}, {}, {})
        if (response.status === 200) {
            yield put({ type: user.GET_USER_GST_SUCCESS, payload: response.data })
        }

    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
    }
    yield put({ type: loading.GET_GST_LIST_LOADING, payload: false });
}

export function* postAvatar(action) {
    let { files, type, ref } = action.payload
    files = Array.from(files);
    const fileList = {
        files: [
            {
                "name": files[0].name,
                "mime_type": files[0].type,
                "size": files[0].size
            }
        ],
        "type": "avatar",

    }

    try {
        const response = yield call(scogo_apis.user.uploadAvtar, {}, {}, {}, { ...fileList });
        const fileResponse = response.data[0];
        files.forEach(async (file) => {
            const f = response.data.find(({ name }) => files.some((fi) => fi.name === name));
            const body = {
                'Content-Type': f.mime_type,
                'key': f.key,
                ...(f.acl ? { 'acl': f.acl } : {}),
                'X-Amz-Date': f.date,
                'X-Amz-Algorithm': f.algorithm,
                'x-amz-meta-uuid': f.uuid,
                'X-Amz-Credential': f.credential,
                'Policy': f.policy,
                'X-Amz-Signature': f.signature
            };

            try {
                const a = await uploadFileToS3WithSignedUrlNew(f.post_url, file, body, { "Content-Type": "multipart/form-data" });
            } catch (error) {
                console.error('Error uploading file:', error);
            }
        });

        if (response.status === 200) {
            yield put({ type: user.UPLAOD_AVATAR_SUCCESS, payload: { file_url: fileResponse.file_url, ref } })
        }

    } catch (error) {

    }
}

export function* enableUser(action) {
    const { userId, formName } = action.payload
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const res = yield call(scogo_apis.user.enableUser, {}, { id: userId }, {});
        if (res.status === 200) {
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: user.ENABLE_USER_SUCCESS, payload: { user: res.data.data } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: res.data.message } })
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something Went wrong!!!' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}
export function* disableUser(action) {
    const { remark, disabled_duration, userId, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const res = yield call(scogo_apis.user.disableUser, {}, { id: userId }, {}, { remark, disabled_duration });
        if (res.status === 200) {
            yield put({ type: user.DISABLE_USER_SUCCESS, payload: { user: res.data.data } });
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: res.data.message } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something Went wrong!!!' } })
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* addUserTags(action) {
    const { tags, userId, newTags } = action.payload;
    try {
        const response = yield call(scogo_apis.user.addUserTags, {}, { userId }, {}, { tags, newTags })
        if (response.status === 201) {
            yield put({ type: user.ADD_USER_TAGS_SUCCESS, payload: { userId, user: response?.data?.data } })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message ? response.data.message : 'Tags Added Successfully!!!' } })
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } })
    }
}

export function* removeUserTags(action) {
    const { tags, userId, newTags } = action.payload;
    try {
        const response = yield call(scogo_apis.user.removeUserTags, {}, { userId }, {}, { tags, newTags })
        if (response.status === 201) {
            yield put({ type: user.REMOVE_USER_TAGS_SUCCESS, payload: { userId, user: response?.data?.data } })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message ? response.data.message : 'Tags Removed Successfully!!!' } })
        }

    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } })
    }
}
export function* addTerritories(action) {
    const { user_id, regions } = action.payload;
    const regionsIds = regions.map(({ id }) => id);
    try {
        const response = yield call(scogo_apis.user.addTerritories, {}, {}, {}, { user_id, region_ids: regionsIds })
        if (response.status === 201) {
            yield put({ type: user.ADD_TERRITORIES_SUCCESS, payload: { regions, user_id } })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Updated Succesfully' } })
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.message } })
    }
};

export function* removeTerritories(action) {
    const { user_id, regions } = action.payload;
    const regionsIds = regions.map(({ id }) => id);
    try {
        const response = yield call(scogo_apis.user.removeTerritories, {}, {}, {}, { user_id, region_ids: regionsIds })
        if (response.status === 201) {
            yield put({ type: user.REMOVE_TERRITORIES_SUCCESS, payload: { regionsIds, user_id } })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Updated Succesfully' } })
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.message } })
    }
};

export function* verifyUserSteps(action) {
    const { userId, verify, formName } = action.payload
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.verifyUserStep, {}, {}, {}, { userId, verify });
        if (response.status === 200) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } })
        }
    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
};

export function* rejectVerifyUserSteps(action) {
    const { userId, verify, formName } = action.payload
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.rejectVerifyUserStep, {}, {}, {}, { userId, verify });
        if (response.status === 200) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } })
        }
    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
};

export function* getUserTerritories(action) {
    const { user_ids } = action.payload
    try {
        yield put({ type: loading.SET_USER_REGIONS_LIST_LOADING, payload: true });
        const response = yield call(scogo_apis.user.getUserTerritories, {}, {}, { users: user_ids.join(',') })
        if (response.status === 200) {
            yield put({ type: user.GET_USER_TERRITORIES_SUCCESS, payload: response.data.data })
        }
    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.SET_USER_REGIONS_LIST_LOADING, payload: false });
};

export function* rolePermissionCheck(action) {
    const { tab } = action.payload;
    const { rolesList } = yield select((state) => state.partners);
    const role = rolesList && rolesList.find(({ path }) => path === tab && !['all', 'verification_pending'].includes(tab));
    const queryParams = {};
    if (role) queryParams.role = role.id;
    try {
        const response = yield call(scogo_apis.user.rolePermissionCheck, {}, {}, queryParams, {});
        if (response.status === 200) {
            yield put({ type: user.ROLES_PERMISSION_CHECK_SUCCESS, payload: { tab, data: response.data } })
        }
    } catch (err) {
        console.log('err:', err)
    }
}

export function* getSendInviteFlow(action) {
    const { role_ids } = action.payload;
    const data = {};
    if (role_ids) data.role_ids = role_ids;
    try {
        yield put({ type: loading.ONBOARDING_FIELDS_LOADING, payload: true })
        const response = yield call(scogo_apis.user.getSendInviteFlow, {}, {}, data);
        if (response.status === 200) {
            yield put({ type: user.GET_SEND_INVITE_FLOW_SUCCESS, payload: { data: response.data.data } });
        } else {
            yield put({ type: user.GET_SEND_INVITE_FLOW_FAILURE, payload: { message: 'Something Went Wrong!!' } });
        }
    } catch (error) {
        yield put({ type: user.GET_SEND_INVITE_FLOW_FAILURE, payload: { message: 'Something Went Wrong!!', } });
    }
    yield put({ type: loading.ONBOARDING_FIELDS_LOADING, payload: false })
}


export function* aadharKycSendOtp(action) {
    const { aadhar, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.kycSendAadhatOtp, {}, {}, {}, { aadhar });
        if (response.status === 201) {
            yield put({
                type: modal.OPEN_CUSTOM_MODAL,
                payload: {
                    heading: `Verify Aadhar`,
                    modalWidth: '35vw',
                    modalHeight: 'auto',
                    modalComponent: <VerifyAadharOtp clientId={response.data.data.clientId} />,
                },
            });
        } else {
            yield put({ type: user.GET_SEND_INVITE_FLOW_FAILURE, payload: { message: 'Something Went Wrong!!' } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: Array.isArray(response.data.messages) ? response.data.messages[0] : response.data.messages || 'Something Went Wrong!!' } });
        }

    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: Array.isArray(error.response.data.messages) ? error.response.data.messages[0] : error.response.data.messages || 'Something Went Wrong!!' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
};

export function* kycVerifyAadhatOtp(action) {
    const { clientId, otp, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.kycVerifyAadhatOtp, {}, {}, {}, { clientId, otp });
        if (response.status === 201) {
            yield put({ type: user.KYC_AADHAR_VERIFY_OTP_SUCCESS, payload: { data: response.data.data } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Aadhar Verified Successfully' } });
        } else {
            yield put({ type: user.KYC_AADHAR_VERIFY_OTP_FAILURE, payload: { message: 'Something Went Wrong!!' } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: Array.isArray(response.data.messages) ? response.data.messages[0] : response.data.messages || 'Something Went Wrong!!' } });
        }
        yield put({ type: modal.CLOSE_MODAL });
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: Array.isArray(error.response.data.messages) ? error.response.data.messages[0] : error.response.data.messages || 'Something Went Wrong!!' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    yield put({ type: modal.CLOSE_MODAL });
}

export function* verifyPancard(action) {
    const { pancard, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.verifyPancard, {}, {}, {}, { pancard });
        if (response.status === 201) {
            yield put({ type: user.VERIFY_PANCARD_SUCCESS, payload: { data: response.data.data } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Pancard Verified Successfully' } });
        } else {
            yield put({ type: user.VERIFY_PANCARD_FAILURE, payload: { message: 'Something Went Wrong!!' } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something Went Wrong!!' } });
        }
        yield put({ type: modal.CLOSE_MODAL });
    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}



export function* deleteUser(action) {
    const { userId, formName, userName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.deleteUser, {}, { userId }, {});
        if (response.status === 200) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'User Deleted Successfully' } });
            yield put({ type: modal.CLOSE_MODAL });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: Array.isArray(error.response.data.messages) ? error.response.data.messages[0] : error.response.data.messages || 'Something Went Wrong!!' } });
    }


    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}


export function* getAdditionalDetails(action) {
    const { user_ids } = action.payload;
    try {
        yield put({ type: loading.SET_USER_LIST_ADDITIONAL_DETAILS_LOADING, payload: true });
        const response = yield call(scogo_apis.user.getAdditionalDetails, {}, {}, { user_ids: user_ids.join(',') });
        if (response.status === 200) {
            yield put({ type: user.GET_ADDITIONAL_DETAILS_SUCCESS, payload: response.data });
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something Went Wrong!!' } });
    }
    yield put({ type: loading.SET_USER_LIST_ADDITIONAL_DETAILS_LOADING, payload: false });
}


export function* getUserDetailsById(action) {
    const { user_id, give_total_withdraw } = action.payload;
    try {
        const queryParams = {};
        if (give_total_withdraw) queryParams.give_total_withdraw = true;
        yield put({ type: loading.SET_USER_DETAILS_BY_ID_LOADING, payload: true });
        const response = yield call(scogo_apis.user.getUserDetail, {}, { userId: user_id }, queryParams);
        if (response.status === 200) {
            yield put({ type: user.GET_USER_DETAILS_BY_ID_SUCCESS, payload: response.data });
        }
    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.SET_USER_DETAILS_BY_ID_LOADING, payload: false });
}


export function* verifyUser(action) {
    const { userId, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.verifyUser, {}, { userId }, {});
        if (response.status === 201) {
            yield put({ type: partners.REFRESH_PARTNER_FILTER_REQUEST });
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } });
        }
    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* rejectVerifyUser(action) {
    const { userId, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.rejectVerifyUser, {}, { userId }, {});
        if (response.status === 201) {
            yield put({ type: partners.REFRESH_PARTNER_FILTER_REQUEST });
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } });
        }
    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}


export function* inviteCustomer(action) {
    const { payload, formName, resetOnSuccess = () => { } } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.inviteCustomer, {}, {}, {}, payload);
        if (response.status === 200) {
            resetOnSuccess();
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } })
        }

    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something Went Wrong!!' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}
export function* availabilityStatus(action) {
    const { id, working_status, dates } = action.payload;

    try {

        const response = yield call(iceberg_apis.workStatus.userAvailability, {}, { id }, {}, { working_status, dates });
        if (response.status === 200) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } })
        }

    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something Went Wrong!!' } });
    }

}

export function* connectRoom(action) {
    const { chat_id, mentions = [] } = action.payload;
    const newLoggedUserData = yield select(state => state.auth.newLoggedUserData);
    try {
        const data = {
            type: 'ANONYMOUS',
            with_pin: true,
            org_id: getOrgId(),
            metadata: {
                created_by: newLoggedUserData?.user?.full_name,
                created_by_email: newLoggedUserData?.user?.email,
                created_by_mobile: newLoggedUserData?.user?.mobile,
                ...(newLoggedUserData?.organizations?.[0] && { org_name: newLoggedUserData?.organizations?.[0].name }),
                created_from_domain: window.location.hostname,
            },
        }

        yield put({ type: loading.CONNECT_LOADING, payload: true })
        const response = yield call(fetch, `${config.connectDomain}/api/createRoom`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        });

        if (response.ok) {
            const data = yield call([response, 'json']);

            const urlToOpen = `${config.connectDomain}/support/${data.pin}/requester?user_name=${newLoggedUserData?.user?.full_name}&t=${getNewAuthToken()}&user_id=${newLoggedUserData?.user?.id}`

            let payload = {
                content: `${mentions.map(({ id, display_name }) => `@[${display_name}](${id})`).join(' ')} You are invited to a new support chat. Please click below to join and help the user: ${config.connectDomain}/support/${data.pin}/enduser`,
                type: "DEFAULT",
                mentions: mentions.map(({ id }) => id),
            };

            yield put({ type: chat.SEND_MESSAGE_REQUEST, payload: { id: chat_id, payload } });
            yield put({ type: modal.CLOSE_MODAL })
            window.open(urlToOpen, "_blank");
        } else {
            const errorText = yield call([response, 'text']);
            yield put({ type: 'CONNECT_ROOM_FAILURE', error: errorText });
        }

    } catch (error) {
        yield put({ type: 'CONNECT_ROOM_FAILURE', error: error.message });
        yield put({ type: loading.CONNECT_LOADING, payload: false })
    }
    yield put({ type: loading.CONNECT_LOADING, payload: false })
}

export function* refreshTeam() {

}

export function* userSettlement(action) {
    const { data, formName, id, refresh = true, closeModal = true } = action.payload;
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
    try {
        const response = yield call(scogo_apis.user.settleWallet, {}, { id }, {}, data);
        if (response.status === 200) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } })
            if (refresh) {
                yield put({ type: serviceRequest.GET_SERVICE_REQUEST_PAYMENTS_REQUEST, payload: { ticketId: data.ticket_id, payload: {} } });
            }
            if (closeModal) {
                yield put({ type: modal.CLOSE_MODAL });
            }
        }

    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something Went Wrong!!' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* refreshLinkedStatus(action) {
    const { userId, formName } = action.payload;
    try {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'info', message: 'Refreshing Linked Status...' } });
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.refreshLinkedStatus, {}, { userId }, {});
        if (response.status === 200) {
            if (response?.data?.data?.is_kyc_verified) yield put({ type: user.REFRESH_LINKED_STATUS_SUCCESS, payload: { userId, is_kyc_verified: response.data.data.is_kyc_verified } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something Went Wrong!!' } });
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something Went Wrong!!' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}


export function* getUserAttendance(action) {
    const { userId, from, to } = action.payload;
    try {
        yield put({ type: loading.USER_ATTENDANCE_LOADING, payload: true });
        const response = yield call(iceberg_apis.user.getAttanedance, {}, { id: userId }, { from, to }, {});
        if (response.status === 200) {
            yield put({ type: user.GET_USER_ATTENDANCE_SUCCESS, payload: { attendance: response.data.data, userId } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something Went Wrong!!' } });
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something Went Wrong!!' } });
    }
    yield put({ type: loading.USER_ATTENDANCE_LOADING, payload: false });
}


export function* updateUserAttendance(action) {
    const { userId, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(iceberg_apis.user.updateTicketAvailability, {}, { id: userId }, {}, payload);
        if (response.status === 200) {
            // yield put({ type: user.UPDATE_USER_ATTENDANCE_SUCCESS, payload: { attendance: response.data.data, userId } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something Went Wrong!!' } });
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something Went Wrong!!' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}


export function* getUserVisitHistory(action) {
    const { userId, from, to } = action.payload;
    try {
        yield put({ type: loading.USER_VISIT_HISTORY_LOADING, payload: true });
        const response = yield call(scogo_apis.user.listVisitHistory, {}, { id: userId }, { from, to }, {});
        if (response.status === 200) {
            yield put({ type: user.GET_USER_VISIT_HISTORY_SUCCESS, payload: { visitHistory: response.data.data, userId } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something Went Wrong!!' } });
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something Went Wrong!!' } });
    }
    yield put({ type: loading.USER_VISIT_HISTORY_LOADING, payload: false });
}

export function* toggleAutoAccept(action) {
    const { userId, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.user.toggle_auto_accept, {}, { id: userId }, {}, payload);
        if (response.status === 201) {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Updated Successfully!!!' } });
            yield put({ type: partners.REFRESH_PARTNER_FILTER_REQUEST });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something Went Wrong!!' } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error?.response?.data?.messages?.[0] || 'Something Went Wrong!!' } });
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* getAutoAcceptProjects(action) {
    const { userId } = action.payload;
    if (!userId) return;
    try {
        yield put({ type: loading.IS_AUTO_ACCEPT_PROJECTS_LOADING, payload: true });
        const response = yield call(scogo_apis.user.getUserDetail, {}, { userId }, {});
        if (response.status === 200) {
            const responseUser = response?.data?.data?.user || response?.data?.user || {};
            const autoAcceptProjects = Array.isArray(responseUser?.auto_accept_projects)
                ? responseUser.auto_accept_projects
                    .filter((project) => project && project.id !== undefined && project.id !== null)
                    .map((project) => ({ id: project.id, name: project.name }))
                : [];
            yield put({ type: user.GET_AUTO_ACCEPT_PROJECTS_SUCCESS, payload: autoAcceptProjects });
        } else {
            yield put({ type: user.GET_AUTO_ACCEPT_PROJECTS_FAILURE, payload: { message: 'Something Went Wrong!!' } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: user.GET_AUTO_ACCEPT_PROJECTS_FAILURE, payload: { message: error } });
    }
    yield put({ type: loading.IS_AUTO_ACCEPT_PROJECTS_LOADING, payload: false });
}

export default function* userSaga() {
    yield takeLatest(user.UPDATE_USER_STATUS_REQUEST, updateUserStatus);
    yield takeLatest(user.UPDATE_PARTNER_PROFILE_REQUEST, updatePartnersProfile);
    yield takeLatest(user.GET_USER_DETAILS_REQUEST, getUserDetails);
    yield takeLatest(user.RETRIEVES_USER_DETAILS_REQUEST, retrievesUserDetails);
    yield takeEvery(user.GET_ONBOARDING_FLOW_REQUEST, getOnboardingFlow);
    yield takeLatest(user.INVITE_USER_POST_REQUEST, inviteUserRequest)
    yield takeLatest(user.GET_ONBOARDING_PROGRESS_REQUEST, getOnboardingProgress);
    yield takeLatest(user.GET_USER_TABLE_SCHEMA_REQUEST, getUserTableSchema);
    yield takeLatest(user.UPDATE_USER_PREFERENCES_REQUEST, updateUserPreferences);
    yield takeLatest(user.POST_IMAGE_URL_REQUEST, postImageUrl)
    yield takeLatest(user.GET_ADD_BANK_DETAILS_FIELD_REQUEST, getAddBankDetailsFields)
    yield takeLatest(user.POST_BANK_DETAILS_REQUEST, postBankDetails)
    yield takeLatest(user.POST_BULK_INVITE_REQUEST, postBulkInvite)
    yield takeLatest(user.UPDATE_BUSINESS_DETAILS_REQUEST, updateBusinessDetail)
    yield takeLatest(user.UPDATE_USER_PROFILE_REQUEST, updateUserProfile)
    yield takeLatest(user.GET_USER_GST_REQUEST, getUserGst)
    yield takeLatest(user.UPLAOD_AVATAR_REQUEST, postAvatar)
    yield takeLatest(user.ENABLE_USER_REQUEST, enableUser)
    yield takeLatest(user.DISABLE_USER_REQUEST, disableUser)
    yield takeLatest(user.ADD_USER_TAGS_REQUEST, addUserTags)
    yield takeLatest(user.REMOVE_USER_TAGS_REQUEST, removeUserTags)
    yield takeLatest(user.ADD_TERRITORIES_REQUEST, addTerritories)
    yield takeLatest(user.REMOVE_TERRITORIES_REQUEST, removeTerritories)
    yield takeLatest(user.VERIFY_USER_STEP_REQUEST, verifyUserSteps)
    yield takeLatest(user.REJECT_VERIFY_USER_STEP_REQUEST, rejectVerifyUserSteps)
    yield takeLatest(user.GET_USER_TERRITORIES_REQUEST, getUserTerritories)
    yield takeLatest(user.ROLES_PERMISSION_CHECK_REQUEST, rolePermissionCheck)
    yield takeLatest(user.GET_SEND_INVITE_FLOW_REQUEST, getSendInviteFlow)
    yield takeLatest(user.KYC_AADHAR_SEND_OTP_REQUEST, aadharKycSendOtp)
    yield takeLatest(user.KYC_AADHAR_VERIFY_OTP_REQUEST, kycVerifyAadhatOtp)
    yield takeLatest(user.VERIFY_PANCARD_REQUEST, verifyPancard)
    yield takeLatest(user.DELETE_USER_REQUEST, deleteUser)
    yield takeLatest(user.GET_ADDITIONAL_DETAILS_REQUEST, getAdditionalDetails)
    yield takeLatest(user.GET_USER_DETAILS_BY_ID_REQUEST, getUserDetailsById)
    yield takeLatest(user.VERIFY_USER_REQUEST, verifyUser)
    yield takeLatest(user.REJECT_VERIFY_USER_REQUEST, rejectVerifyUser)
    yield takeLatest(user.INVITE_CUSTOMER_REQUEST, inviteCustomer)
    yield takeLatest(user.USER_AVAILABILITY_STATUS_REQUEST, availabilityStatus)
    yield takeLatest(user.REFRESH_TEAMS, refreshTeam)
    yield takeLatest(user.CONNECT_ROOM_REQUEST, connectRoom)
    yield takeLatest(user.USER_SETTLEMENT_REQUEST, userSettlement)
    yield takeLatest(user.REFRESH_LINKED_STATUS_REQUEST, refreshLinkedStatus)
    yield takeLatest(user.GET_USER_ATTENDANCE_REQUEST, getUserAttendance)
    yield takeLatest(user.UPDATE_USER_ATTENDANCE_REQUEST, updateUserAttendance)
    yield takeLatest(user.GET_USER_VISIT_HISTORY_REQUEST, getUserVisitHistory)
    yield takeLatest(user.TOGGLE_AUTO_ACCEPT_REQUEST, toggleAutoAccept)
    yield takeLatest(user.GET_AUTO_ACCEPT_PROJECTS_REQUEST, getAutoAcceptProjects)
}

function createRoomApi(payload) {
    return fetch('https://connect.development.scogo.ai/api/createRoom', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    }).then(response => {
        if (!response.ok) {
            throw new Error('Failed to create room');
        }
        return response.json();
    });
}
